module.exports = __webpack_public_path__ + "static/media/tournament-lobby.13af51b8.png";